export const APP_NAME = 'Ziri Photography';